import MuiDivider from '@mui/material/Divider';

export const Divider = MuiDivider;
